module.exports = __webpack_public_path__ + "static/img/stu-bottom.4695c954.png";